import CONSTANTS from "../../assets/js/Constants";

//reducer gồm các hàm update trạng thái dựa vào kết quả từ api
const fuel_change_report = {};
export default function (state = fuel_change_report, { type, payload }) {
    switch (type) {
        case CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_VEHICLE_LIST:
            return { ...state, vehicleList: payload };
        case CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_REPORT_DATA_ACTION:
            return { ...state, reportData: payload };
        case CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_DOWNLOAD_REPORT_ACTION:
            return { ...state, downloadReport: payload };
        default:
            return { ...state };
    }
}